import React from 'react'

const ManagePayments = () => {
  return (
    <div>
      ManagePayments
    </div>
  )
}

export default ManagePayments
